module.exports = __webpack_public_path__ + "static/media/UPV.9f3731ad.png";